<template>
  <div class="MediaDetail">
    <iframe class="word" v-if="detail.bookType === 2" :src="`${iframeUrl}&furl=${detail.bookHref || ''}`" :key="detail.id"></iframe>
  </div>
</template>

<script>
export default {
  name: 'BookSource',
  data () {
    return {
      detail: {},
      iframeUrl: ''
    };
  },

  watch: {
    '$route.query': {
      handler () {
        this.handleRow(this.$route.query.detail);
      },
      immediate: true
    }
  },
  mounted () {
    window.addEventListener('resize', this.resize, false);
    this.getIframe();
  },
  methods: {

    /* 调用office 365 */
    getIframe () {
      this.$http.get('file/view').then((res) => {
        this.iframeUrl = res.data.url;
      });
    },

    handleRow (bookObj) {
      let { detail } = this;
      detail = bookObj || {};
      this.detail = detail;
    },

    /* 判断手机处于横屏还是竖屏 */
    resize () {
      const { popupProp } = this;
      let width = document.documentElement.clientWidth;
      let heigth = document.documentElement.clientHeight;
      // 横屏
      if (width > heigth) {
        popupProp.position = 'left';
        popupProp.width = '60%';
        popupProp.heigth = '100vh';
      } else {
        popupProp.position = 'bottom';
        popupProp.width = '100%';
        popupProp.heigth = '60%';
      }
    }
  },
  beforeDestroyed () {
    window.addEventListener('resize', this.resize, false);
  }
};
</script>

<style lang="less" scoped>
.MediaDetail {
  position: relative;
  height: calc(100vh - 94px);
  .top-nav-bar {
    flex-shrink: 0;
    width: 100%;
    height: 94px;

    /deep/.van-nav-bar {
      position: fixed;
      top: 0;
      right: 0;
      left: 0;
      z-index: 999;
      width: 100%;
      height: 94px;
      margin: auto;
      background-color: #fff;

      &::after {
        border: none;
      }

      .van-nav-bar__title {
        font-size: 34px;
        font-weight: bold;
        line-height: 94px;
        color: #222;
        color: #1a1a1a;
      }

      .van-nav-bar__left {
        left: 0;
      }

      .van-nav-bar__right {
        right: 0;
      }

      .van-nav-bar__left,
      .van-nav-bar__right {
        z-index: 999;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 94px;
        padding: 0 30px;
      }

      .back-arrow {
        width: 32px;
        height: 32px;
        background-image: url("~@/assets/images/icon_backArrow_01.png");
        background-size: contain;
      }
      .btn {
        width: 96px;
        height: 56px;
        background: linear-gradient(93deg, #2E86FF 0%, #5FA9FF 100%);
        border-radius: 8px;
        font-size: 24px;
        font-weight: 500;
        line-height: 46px;
        color: #fff;
      }
    }
  }
  .audio {
    width: 100%;
  }
  #video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 600px;
  }
  .word {
    width: 100vw;
    height: 100%;
  }
  .rich {
    padding: 30px;
    width: 100%;
    background-color: #fff !important;
    font-size: 24px;
  }
  .vanImg {
    width: 100%;
  }
  .btn {
    position: fixed;
    width: 60px;
    height: 60px;
    right: 28px;
    bottom: 40px;
    background: url('~@/assets/images/study/icon_menu_01.png') no-repeat center center/cover;
    z-index: 10;
  }
  .popup {
    width: 100vw;
    height: 686px;
    background: rgba(0,0,0,.9);
    border-radius: 16px 16px 0px 0px;
    display: flex;
    flex-direction: column;
    .header {
      height: 128px;
      font-size: 36px;
      color: #fff;
      padding: 40px;
    }
    .list {
      flex: 1;
      height: 0;
      overflow: auto;
      padding: 0 40px;
      .item {
        margin-bottom: 40px;
        .top {
          margin-bottom: 15px;
          display: flex;
          align-items: center;
          .line {
            width: 8px;
            height: 32px;
            background: #5FA9FF;
            border-radius: 4px;
          }
          .title {
            margin-left: 20px;
            font-size: 32px;
            color: #fff;
          }
        }
        .list_none{
          font-size: 30px;
          padding: 0 68px;
          color: #969799;
        }
        .row {
          padding: 15px 0;
          display: flex;
          align-items: center;
          .icon {
            width: 40px;
            height: 40px;
          }
          .value {
            margin-left: 16px;
            font-size: 28px;
            font-weight: 500;
            color: #fff;
          }
          .active {
            color: #5FA9FF !important;
          }
          .tag {
            margin-left: 16px;
            width: 60px;
            height: 34px;
            border: 1px solid #FFFFFF;
            border-radius: 4px;
            font-size: 24px;
            font-weight: 500;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
        .tagActive {
          color: #5FA9FF !important;
          border: 2px solid #5FA9FF !important;
          font-size: 20px;
          margin-left: 12px;
          border-radius: 20px;
          padding: 4px 18px;
        }
      }
    }
  }
  .isWhite{
    background: #FFFFFF;
    .header{
      color: #333333;
      text-align: center;
      font-weight: bold;
    }
    .list{
      padding: 0;
      .item{
        .top{
          padding: 0 40px;
          .title{
            color: #333444;
            font-size: 30px;
            font-weight: bold;
            color: #333444;
          }
        }
        .row{
          padding-left: 40px;
          padding-right: 40px;
          .value {
            color: #67677A;
          }
          .tag {
            margin-left: 16px;
            width: 60px;
            height: 34px;
            border: 1px solid #FFFFFF;
            border-radius: 4px;
            font-size: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #67677A;
          }
        }
        .active {
         background: #EFF6FF !important;
        }
      }
    }
  }
}
</style>